module.exports = __webpack_public_path__ + "static/img/dot-grid.a6b7115.svg";